export default __webpack_public_path__ + "static/media/icon_log_out.9609fc51.svg";